/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// PRESETS

export const GET_PRESETS = 'GET_PRESETS';
export const GET_PRESETS_SUCCESS = 'GET_PRESETS_SUCCESS';

export const SEARCH_PRESETS = 'SEARCH_PRESETS';
export const SEARCH_PRESETS_SUCCESS = 'SEARCH_PRESETS_SUCCESS';

export const CREATE_PRESET = 'CREATE_PRESET';
export const CREATE_PRESET_SUCCESS = 'CREATE_PRESET_SUCCESS';

export const EDIT_PRESET = 'EDIT_PRESET';
export const EDIT_PRESET_SUCCESS = 'EDIT_PRESET_SUCCESS';

export const DELETE_PRESET = 'DELETE_PRESET';
export const DELETE_PRESET_SUCCESS = 'DELETE_PRESET_SUCCESS';

// IEMS

export const GET_ITEMS = 'GET_ITEMS';
export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';

export const GET_ITEM_SINGLE = 'GET_ITEM_SINGLE';
export const GET_ITEM_SINGLE_SUCCESS = 'GET_ITEM_SINGLE_SUCCESS';

export const SEARCH_ITEMS = 'SEARCH_ITEMS';
export const SEARCH_ITEMS_SUCCESS = 'SEARCH_ITEMS_SUCCESS';

export const CREATE_ITEM = 'CREATE_ITEM';
export const CREATE_ITEM_SUCCESS = 'CREATE_ITEM_SUCCESS';

export const EDIT_ITEM = 'EDIT_ITEM';
export const EDIT_ITEM_SUCCESS = 'EDIT_ITEM_SUCCESS';

export const DELETE_ITEM = 'DELETE_ITEM';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';

// ABILITYS

export const GET_ABILITY_BARS = 'GET_ABILITY_BARS';
export const GET_ABILITY_BARS_SUCCESS = 'GET_ABILITY_BARS_SUCCESS';

export const GET_ABILITY_BAR_SINGLE = 'GET_ABILITY_BAR_SINGLE';
export const GET_ABILITY_BAR_SINGLE_SUCCESS = 'GET_ABILITY_BAR_SINGLE_SUCCESS';

export const SEARCH_ABILITY_BARS = 'SEARCH_ABILITY_BARS';
export const SEARCH_ABILITY_BARS_SUCCESS = 'SEARCH_ABILITY_BARS_SUCCESS';

export const CREATE_ABILITY_BAR = 'CREATE_ABILITY_BAR';
export const CREATE_ABILITY_BAR_SUCCESS = 'CREATE_ABILITY_BAR_SUCCESS';

export const EDIT_ABILITY_BAR = 'EDIT_ABILITY_BAR';
export const EDIT_ABILITY_BAR_SUCCESS = 'EDIT_ABILITY_BAR_SUCCESS';

export const DELETE_ABILITY_BAR = 'DELETE_ABILITY_BAR';
export const DELETE_ABILITY_BAR_SUCCESS = 'DELETE_ABILITY_BAR_SUCCESS';

export const CLEAR_ABILITY_BAR_OBJ = 'CLEAR_ABILITY_BAR_OBJ';

// ERROR

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const ERROR = 'EQUIPMENT_ERROR';